package com.mxpainting.pages

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import com.mxpainting.Strings
import com.mxpainting.rememberLanguage
import com.mxpainting.components.layouts.PageLayout
import com.mxpainting.components.sections.ServicesCarousel
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.classNames
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.core.Page
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.dom.A
import org.jetbrains.compose.web.dom.B
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.H2
import org.jetbrains.compose.web.dom.Li
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text
import org.jetbrains.compose.web.dom.Ul
import org.jetbrains.compose.web.dom.Section

@Page
@Composable
fun ServicesPage() {
    val language by rememberLanguage()

    PageLayout {
        Column(Modifier.fillMaxSize()) {
            ServicesCarousel()

            Section(Modifier.classNames("section-dark").toAttrs()) {
            
            Div(Modifier.classNames("container").padding(2.cssRem).toAttrs()) {
                H2 { Text(Strings.servicesHeader[language]!!) }
                P { Text(Strings.servicesIntro[language]!!) }
                
                Ul {
                    Li { B { Text(Strings.servicesInteriorTitle[language]!!) } ; Text(Strings.servicesInteriorDesc[language]!!) }
                    Li { B { Text(Strings.servicesExteriorTitle[language]!!) } ; Text(Strings.servicesExteriorDesc[language]!!) }
                    Li { B { Text(Strings.servicesCabinetTitle[language]!!) } ; Text(Strings.servicesCabinetDesc[language]!!) }
                    Li { B { Text(Strings.servicesCommercialTitle[language]!!) } ; Text(Strings.servicesCommercialDesc[language]!!) }
                }

                P { 
                    Text(Strings.servicesAreaPart1[language]!!)
                    B { Text(Strings.servicesAreaBold[language]!!) }
                    Text(Strings.servicesAreaPart2[language]!!)
                }

                P {
                    A(href = "/contact", attrs = Modifier.classNames("btn", "btn-primary", "py-3", "px-5").toAttrs()) { 
                        Text(Strings.servicesFreeEstimate[language]!!) 
                    }
                }
            }
        }
            Div(Modifier.classNames("container").padding(2.cssRem).toAttrs()) {

                H2 { Text(Strings.warrantyHeader[language]!!) }
 
                P(
                    Modifier
                        .styleModifier { 
                            property("white-space", "pre-wrap") 
                        }
                        .toAttrs()
                ) {
                    Text(Strings.warrantyText[language]!!)
                }

                A(href = "/contact", attrs = Modifier.classNames("btn", "btn-primary", "py-3", "px-5").toAttrs()) { 
                        Text(Strings.servicesFreeEstimate[language]!!) 
                }
            }
        }
    }
}
